<template>
   <ShowControl  @revert="revertClick"  :title="title" ref="showControl" :knowledgeType="knowledgeType">
    <div style="height: 90%;width: 100%;margin-top: 1%;display: flex;justify-content: center;">
      <div style="width: 90%;display: flex;flex-direction: column;">
        <div style="flex: 1;">
          <el-tabs type="card" v-model="knowledgeType" class="demo-tabs" @tab-click="AttractClick">
          <el-tab-pane label="行业专家邀请"
                      :name="Global.KnowledgeTypeList.filter(c=>c.name == '行业专家邀请')[0].value" style="height: 82%;">
                      <div style="height: 90%;width: 100%;margin-top: 1%;overflow-x: hidden;overflow-y: auto;">
                        <div style="display: flex; justify-content: center;">
                              <el-form :model="expertForm"
                                      ref="expertForm"
                                      :rules="rules"
                                      label-width="120px">
                                <el-form-item label="行业类型:"
                                              prop="inviteTypeID">
                                  <el-select multiple
                                            collapse-tags
                                            collapse-tags-tooltip
                                            @change="selectExpertType"
                                            size="medium"
                                            :disabled="isExpertdisabled"
                                            v-model="expertForm.inviteTypeID">
                                    <el-option v-for="item in CompanyTypeList"
                                              :key="item.id"
                                              :label="item.name"
                                              :value="item.id"></el-option>
                                  </el-select>
                                </el-form-item>
                                <el-form-item label="行业专家:"
                                              :required="inviteID"
                                              prop="inviteID">
                                  <el-select v-model="expertForm.inviteID"
                                            multiple
                                            filterable
                                            placeholder="请选择专家"
                                            collapse-tags
                                            collapse-tags-tooltip
                                            :disabled="isExpertdisabled"
                                            style="width: 240px">
                                    <el-option v-for="item in ExpertList"
                                              :key="item.id"
                                              :label="`${item.name}----专家费：${String(item.cost).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}元`"
                                              :value="item.id" />
                                  </el-select>
                                </el-form-item>
                                <el-form-item>
                                  <el-button type="primary" v-if="SModelExpertList.filter((t) => t.state != Global.SModel.Delete ).length == 0"
                                            @click="expertOnsubmit()">{{SModelExpertList.filter((t) => t.state != Global.SModel.Delete ).length > 0
                                                                                            ? "取消"
                                                                                            : "邀请"
                                                                                        }}</el-button>
                                  <el-button type="primary" @click="AIGenerate()" >AI助手</el-button>
                                </el-form-item>
                              </el-form> 
                        </div>
                        <div style="display: flex; justify-content: center;">
                          <div style="font-size: 14px;font-weight: bold; margin-left: 5px; color: red;">点击AI助手，可利用AIGC（生成式人工智能）技术自动生成主题招商演讲邀约方案。</div>
                        </div>
                        <!-- <AIGenerateCard v-if="AIGenerateCardView" :AICardtransfer="AItransfer"></AIGenerateCard> -->
                      </div>
          </el-tab-pane>
          <el-tab-pane label="企业招商"
                      :name="Global.KnowledgeTypeList.filter(c=>c.name == '企业招商')[0].value" style="height: 82%;">
                      <!-- <ThemeEnterpriseCard></ThemeEnterpriseCard> -->
                      <div style="height: 90%;width: 100%;margin-top: 1%;overflow-x: hidden;overflow-y: auto;">
                      <div v-if="Companyview" style="display: flex;justify-content: center;">
                      <el-form :model="CompanyForm"
                                ref="CompanyForm"
                                :rules="rules"
                                label-width="120px">
                        <el-form-item label="企业类型:"
                                      prop="inviteTypeID">
                          <el-select size="medium"
                                      multiple
                                      collapse-tags
                                      collapse-tags-tooltip
                                      :disabled="isCompanydisabled"
                                      v-model="CompanyForm.inviteTypeID">
                            <el-option v-for="item in CompanyTypeLists"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="注:">
                          <label>可根据<span style="color: red;">企业类型，企业名称，成本</span>进行远程搜索</label>
                        </el-form-item>
                        <el-form-item label="企业:"
                                      :required="inviteID"
                                      prop="inviteID">
                          <el-select v-model="CompanyForm.inviteID"
                                      :disabled="isCompanydisabled"
                                      multiple
                                      filterable
                                      collapse-tags
                                      collapse-tags-tooltip
                                      :loading="loading"
                                    :remote="true"
                                    :remote-method="loadData"
                                  placeholder="请搜索"
                                  @change="countCost"
                                      style="width: 215px">
                            <el-option v-for="item in CompanyList"
                                        :key="item.id"
                                        :label="`${item.compCh}----${item.name}----成本：${String(item.cost).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}元`"
                                        :value="item.id" />
                          </el-select>
                        </el-form-item>
                        <el-form-item>
                          <el-button type="primary" v-if="SModelCompanyList.filter((t) => t.state != Global.SModel.Delete ).length == 0"
                                      @click="CompanyOnsubmit()">{{SModelCompanyList.filter(
                                                                                    (t) =>
                                                                                      t.state != Global.SModel.Delete
                                                                                  ).length > 0
                                                                                    ? "取消"
                                                                                    : "邀请"
                                                                                }}</el-button>
                            <el-button type="primary" @click="AIGenerate()" >AI助手</el-button>                  
                        </el-form-item>
                      </el-form>
                    </div>
                    <div style="display: flex; justify-content: center;">
                      <div style="font-size: 14px;font-weight: bold;margin-left: 5px; color: red;">点击AI助手，可利用AIGC（生成式人工智能）技术自动生成主题招商演讲邀约方案。</div>
                    </div>
                    </div>
          </el-tab-pane>
        </el-tabs>
        </div>
        <div style="flex: 2;">
          <AIGenerateCard v-if="AIGenerateCardView" :AICardtransfer="AItransfer"></AIGenerateCard>
        </div>
      </div>
    </div>
  </ShowControl>
</template>

<script>
import { mapState } from "vuex";
import ShowControl from "../../UserControl/ShowControl.vue"
import AIGenerateCard from "../../Card/AIGenerate/AIGenerateCard.vue"
export default {
  inject: ['GetAllAttractInvestment'],
  components: {
    ShowControl,
    AIGenerateCard
  },
  data () {
    return {
      loading:false,
        flowID: localStorage.getItem("flowID"),
        expertview: true,
        Companyview: true,
        SModelExpertList: [],
        SModelCompanyList: [],
        AttractInvestform: {},
        isExpertdisabled: false,
        isCompanydisabled: false,
        ExpertList: [],
        CompanyList: [],
        CompanyTypeList: [],
        CompanyTypeLists: [],
        expertForm: {
          inviteID: [],
          inviteTypeID: [],
        },
        CompanyForm: {
          inviteID: [],
          inviteTypeID: [],
        },
        CompanyInput: {
          currentPage: 1,
          pagesize: 999,
          companyTypeId: '',
          query:''
        },
        rules: {
          inviteID: [{ required: true, message: "请选择企业", trigger: "blur" },],
        },
        attractInvestmentCompany: [],
        attractInvestmentExpert: [],
        CompanyCost:0,
        themeShow: false,
        childTitle: '',
        AIGenerateCardView: false,
        AItransfer: {
        },
        AIID:0,
        typedText: '',
        AI:{},
        value : null,
        title: '主题演讲招商',
        knowledgeType: 0,
    }
  },
  computed: {
    ...mapState({
      Round: (state) => state.user.round,
      MarketCost: (state) => state.user.marketCostStatistics,
      ChatShow:(state) => state.user.chatShows,
    }),
  },
  created () {
    this.GetAllCompanyType()
    this.GetSModelExpert()
    this.value = 0
    this.GetAI()
  },
  mounted () {
    this.knowledgeType = this.Global.KnowledgeTypeList.filter(c=>c.name == '行业专家邀请')[0].value
    this.$refs.showControl.receiveValue(true);
  },
  methods: {
    revertClick(){
      this.$router.push("/MiceMarketing")
    },
    AIGenerate(){
      this.value = 1
      this.GetAI(1)
    },
    GetAI(){
      this.AI={}
      this.$http.get(`StudentData/GetAI?Round=${this.Round}&Type=${this.Global.AiEnum.主题招商演讲}&ParentID=0`).then((res)=>{
        if (res.success) {
          this.AI = res.dynamicObj
          if (this.value == 1) {
            this.GetMeadiaData()
          } else if(this.AI != null) {
            this.AIID = res.dynamicObj.id
            this.typedText= res.dynamicObj.answer
            this.GetMeadiaData()
          }else{
            this.AItransfer ={
              problem:this.template,
              type:this.Global.AiEnum.主题招商演讲,
              parentID: 0,
              id:this.AI===null?0:this.AIID
            }
            this.AIGenerateCardView = true
          }
        } else {
            this.ischat = false;
          return this.$message.warning(res.message)
        }
      })
    
    },
    GetMeadiaData () {
      this.$http
        .get(
          "StudentData/GetMeadiaData?round=" + this.Round
        )
        .then((res) => {
          if (res.success) {
            let data = res.dynamicObj;
            var starData = this.filter.formatDate( data.starData , "yyyy年M月d日")
            var endData =this.filter.formatDate( data.endData , "yyyy年M月d日")
            var copywriting = `会展名称：海丝博览会；会展主题：${data.themes}；目标市场：${data.targetMarket}；会展场馆：${data.exhibitionVenue}；大展位数量${data.largeBoothArea}个；中展位数量${data.mediumBoothArea}个；小展位数量${data.smallBoothArea}个；开始日期：${starData}；结束日期：${endData}；`
            this.generate(copywriting)
          } else {
            return this.$message.error(res.message);
          }
        });
    },
    generate(copywriting){
      const xhr = new XMLHttpRequest();
      xhr.open('GET', this.Global.chaturl + `api/Chat/ChatTeampleMsg?teampid=${this.Global.chatTemplateID.主题招商演讲}`);
      xhr.setRequestHeader('Content-Type', 'text/event-stream');
      xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
            if(xhr.responseText=="")
            {
              this.$message.warning("AI生成失败，请联系管理员！");
              return;
            }
            // 避免接受过程中缺少字符
            const responseData=  xhr.responseText.replace(/\s+/g, '').trim();
            this.template=decodeURIComponent(JSON.parse(responseData).data).replace("{}",copywriting);
            this.AItransfer ={
              problem:this.template,
              type:this.Global.AiEnum.主题招商演讲,
              answer:this.value == 1? '' : this.typedText,
              parentID: 0,
              id:this.AI===null?0:this.AIID
            }
            this.AIGenerateCardView =true
          }
        }
      }
      xhr.send();
    },
    GetAllCompanyType () {
      this.$http.get("CompanyType/GetAllCompanyType?round=" + this.Round).then((res) => {
        if (res.success) {
          this.CompanyTypeList = res.dynamicObj;
          this.CompanyTypeLists = res.dynamicObj;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    AttractClick (tab, event) {

      console.log(tab, event);
    },
    selectExpertType (val) {
      this.GetAllExpert(val);
    },
    loadData(query) {
        this.loading = true;
        this.CompanyInput.query=query;
        this.CompanyInput.companyTypeId=this.CompanyForm.inviteTypeID.join(',');
        this.fetchData()
           .then(response => {
           this.CompanyList = response.data;
           this.total = response.totalRecord;
           this.loading = false;
           })
           .catch(error => {
           console.error('Failed to load data:', error);
           this.loading = false;
       });
     },
      fetchData() {
          return new Promise((resolve, reject) => {
          setTimeout(() => {
           console.log(reject);
           this.$http.post(`Company/GetCompanyLsit`,this.CompanyInput).then((res) => {
           if (res.success) {
             var data=res.dynamicObj;
             var totalRecord = res.dynamicObj.totalRecord;
             resolve({ data,totalRecord });
             } else {
             return this.$message.error(res.message)
             }
      }) 
         }, 1000);
      });
      },
      countCost(val)
      {
        this.CompanyList.filter(c=>val.includes(c.id)).forEach((rs) => {
          this.CompanyCost += rs.cost;
        });
      },
    GetAllExpert (id) {
      var list = this.ExpertList.filter(c => this.expertForm.inviteID.includes(c.id));
      list.forEach((rs) => {
        this.attractInvestmentExpert.push({ id: rs.id, companyTypeID: rs.companyTypeID });
      });
      this.$http.get("Expert/GetAllExpert?companyTypeIDs=" + id).then((res) => {
        if (res.success) {
          this.ExpertList = res.dynamicObj;
          this.attractInvestmentExpert = this.attractInvestmentExpert.filter(c => id.includes(c.companyTypeID));
          let ids = [];
          this.attractInvestmentExpert.forEach((rs) => {
            ids.push(rs.id);
          })
          this.expertForm.inviteID = this.expertForm.inviteID.filter(c => ids.includes(c))
        } else {
          this.$message.error(res.message);
        }
      });
    },
    GetSModelExpert () {
      this.$http
        .get(
          "SModel/GetTypeSModel?round=" +
          this.Round +
          "&typename=S_AttractInvestment"
        )
        .then((res) => {
        if (res.success) {
          this.SModelExpertList = res.dynamicObj.filter(c => c.attractInvestmentType == this.Global.AttractInvestment.ThemeExpert);
          this.SModelCompanyList = res.dynamicObj.filter(c => c.attractInvestmentType == this.Global.AttractInvestment.ThemeEnterprise);
          if (this.SModelCompanyList.filter(c => c.state != this.Global.SModel.Delete).length > 0) {
              this.$http.get("Company/GetPurchaseCompany?round=" + this.Round + "&attractInvestmentType=" + this.Global.AttractInvestment.ThemeEnterprise).then((res) => {
                if (res.success) {
                  var data = res.dynamicObj;
                  this.CompanyList = data.companyList;
                  this.CompanyTypeLists = data.companyTypeList;
                  this.isCompanydisabled = true;
                  var company = this.SModelCompanyList.filter(c => c.state != this.Global.SModel.Delete)[0];
                  let inviteID = []
                  company.inviteID.split(',').filter(c => c).forEach((rs) => {
                    inviteID.push(parseInt(rs));
                  });
                  this.CompanyForm.inviteID = inviteID
                  let inviteTypeID = []
                  company.inviteTypeID.split(',').filter(c => c).forEach((rs) => {
                    inviteTypeID.push(parseInt(rs));
                  });
                  this.CompanyForm.inviteTypeID = inviteTypeID;
                } else {
                  this.$message.error(res.message);
                }
              });
            } else {
              this.isCompanydisabled = false;
            }
          if (this.SModelExpertList.filter(c => c.state != this.Global.SModel.Delete).length > 0) {
            this.$http.get("Expert/GetPurchaseExpert?round=" + this.Round).then((res) => {
              if (res.success) {
                var data = res.dynamicObj;
                this.ExpertList = data.expertList;
                this.CompanyTypeList = data.companyTypeList;
                this.isExpertdisabled = true;
                var expert = this.SModelExpertList.filter(c => c.state != this.Global.SModel.Delete)[0];
                let inviteID = []
                expert.inviteID.split(',').filter(c => c).forEach((rs) => {
                  inviteID.push(parseInt(rs));
                });
                this.expertForm.inviteID = inviteID
                let inviteTypeID = []
                expert.inviteTypeID.split(',').filter(c => c).forEach((rs) => {
                  inviteTypeID.push(parseInt(rs));
                });
                this.expertForm.inviteTypeID = inviteTypeID;
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            this.isExpertdisabled = false;
          }
        } else {
          return this.$message.error(res.message);
        }
      });
    },
    expertOnsubmit () {
        if (this.flowID != this.Global.FlowList.招商) {
          this.$message.error("当前流程阶段不是招商，无法进行操作！");
          return;
        }
        let that = this;
        that.$refs.expertForm.validate((valid) => {
          if (valid) {
            let pranm=
            {
                ids :  that.expertForm.inviteID
            }
            this.$http.post("Expert/GetExpertCost",pranm).then((ress) => {
              if (ress.success) {
                let list = that.SModelExpertList;
              let cost = ress.dynamicObj;
              if (list.filter(c => c.state != that.Global.SModel.Delete).length > 0) {
                list[0].state = that.Global.SModel.Delete;
                that.$http
                  .post("SModel/PushStrategy", that.Global.getsmodel(list))
                  .then((res) => {
                    if (res.success) {
                      this.Global.GetBudget(-cost);
                      that.Global.sendmsgmd(
                        "会展营销",
                        '取消了主题招商演讲专家，增加了' + cost + '元',
                        1
                      );
                      var incomet = [{
                        buissType: that.Global.PayType.特邀专家费,
                        round: this.Round,
                      }];
                      that.API.pushIncomet(incomet,1);
                      that.GetSModelExpert();
                      // that.GetAllAttractInvestment();
                      this.GetAllCompanyType();
                      that.$store.commit("marketStatistics", !this.MarketCost);  
                      that.API.createTaskBar(that.Round,that.Global.EnumUserStatus.delete,'主题招商演讲专家');
                    } else {
                      that.$message.error(res.message);
                      return false;
                    }
                  });
              } else {
                if (!this.Global.GetBudget(cost)) {
                  this.$message.error("资金不足");
                  this.loading = false;
                  return;
                }
                if (list.length == 0) {
                  list = [];
                  list.push(that.expertForm)
                  list[0].uuid = that.uuid.guid();
                  list[0].state = that.Global.SModel.Create;
                } else {
                  let uuid = list[0].uuid;
                  list = [];
                  list.push(that.expertForm)
                  list[0].state = that.Global.SModel.Update;
                  list[0].uuid = uuid;
                }
                list[0].round = that.Round;
                list[0].type = "S_AttractInvestment";
                list[0].sTTime = that.filter.formatDate(new Date());
                list[0].attractInvestmentType = this.Global.AttractInvestment.ThemeExpert;
                list[0].personnelType = this.Global.AttractInvestmentType.Expert;
                list[0].inviteID = that.expertForm.inviteID.join(',');
                list[0].inviteTypeID = that.expertForm.inviteTypeID.join(',');
                list[0].cost = cost;
                that.$http
                  .post("SModel/PushStrategy", that.Global.getsmodel(list))
                  .then((res) => {
                    if (res.success) {
                      that.Global.sendmsgmd(
                        "会展营销",
                        '主题演讲招商邀请了专家，扣减了' + cost + '元',
                        1
                      );
                      var incomet = [{
                        buissType: that.Global.PayType.特邀专家费,
                        buissValue: cost,
                        name: '特邀专家费',
                        describe: '',
                        round: this.Round,
                      }];
                      that.API.pushIncomet(incomet,0);
                      that.GetSModelExpert();
                      // that.GetAllAttractInvestment();
                      that.$store.commit("marketStatistics", !this.MarketCost);  
                      this.$store.commit("chatShow",{ isOperate : !this.ChatShow, chatValue: this.Global.OperateType.主题招商专家 });  
                      that.API.createTaskBar(that.Round,that.Global.EnumUserStatus.normal,'主题招商演讲专家');
                    } else {
                      that.$message.error(res.message);
                      return false;
                    }
                  });
                }
                }
              });
          }
        });
    },
    CompanyOnsubmit () {
      console.log( this.CompanyList);
      if (this.flowID != this.Global.FlowList.招商) {
        this.$message.error("当前流程阶段不是招商，无法进行操作！");
        return;
      }
      let that = this;
      that.$refs.CompanyForm.validate((valid) => {
        if (valid) {
          let pranm=
          {
              ids : that.CompanyForm.inviteID
          }
          this.$http.post("CompanyType/GetCompanyCost",pranm).then((ress) => {
            if (ress.success) {
            let list = that.SModelCompanyList;
            let cost = ress.dynamicObj;
            // this.CompanyList.filter(c => that.CompanyForm.inviteID.includes(c.id)).forEach((rs) => {
            //   cost += rs.cost;
            // });
            if (list.filter(c => c.state != that.Global.SModel.Delete).length > 0) {
              list[0].state = that.Global.SModel.Delete;
              that.$http
                .post("SModel/PushStrategy", that.Global.getsmodel(list))
                .then((res) => {
                  if (res.success) {
                    this.Global.GetBudget(-cost);
                    that.Global.sendmsgmd(
                      "会展营销",
                      `取消了主题招商演讲企业，增加了` + cost + '元',
                      1
                    );
                    var incomet = [{
                      buissType: that.Global.PayType.主题演讲企业成本,
                      round: this.Round,
                    }];
                    that.API.pushIncomet(incomet,1);
                    that.GetSModelExpert();
                    // that.GetAllAttractInvestment();
                    this.GetAllCompanyType();
                    that.$store.commit("marketStatistics", !this.MarketCost);  
                        that.API.createTaskBar(that.Round,that.Global.EnumUserStatus.delete,'主题招商演讲企业');
                  } else {
                    that.$message.error(res.message);
                    return false;
                  }
                });
            } else {
              if (!this.Global.GetBudget(cost)) {
                this.$message.error("资金不足");
                this.loading = false;
                return;
              }
              if (list.length == 0) {
                list = [];
                list.push(that.CompanyForm)
                list[0].uuid = that.uuid.guid();
                list[0].state = that.Global.SModel.Create;
              } else {
                let uuid = list[0].uuid;
                list = [];
                list.push(that.CompanyForm)
                list[0].state = that.Global.SModel.Update;
                list[0].uuid = uuid;
              }
              list[0].round = that.Round;
              list[0].type = "S_AttractInvestment";
              list[0].sTTime = that.filter.formatDate(new Date());
              list[0].attractInvestmentType = this.Global.AttractInvestment.ThemeEnterprise;
              list[0].inviteID = that.CompanyForm.inviteID.join(',');
              list[0].inviteTypeID = that.CompanyForm.inviteTypeID.join(',');
              list[0].cost = cost;
              that.$http
                .post("SModel/PushStrategy", that.Global.getsmodel(list))
                .then((res) => {
                  if (res.success) {
                    that.Global.sendmsgmd(
                      "会展营销",
                      '主题演讲招商邀请了企业，扣减了' + cost + '元',
                      1
                    );
                    var incomet = [{
                      buissType: that.Global.PayType.主题演讲企业成本,
                      buissValue: cost,
                      name: '主题演讲企业成本',
                      describe: '',
                      round: this.Round,
                    }];
                    that.API.pushIncomet(incomet,0);
                    that.GetSModelExpert();
                    // that.GetAllAttractInvestment();
                    that.$store.commit("marketStatistics", !this.MarketCost);  
                    this.$store.commit("chatShow",{ isOperate : !this.ChatShow, chatValue: this.Global.OperateType.主题招商企业 });  
                    that.API.createTaskBar(that.Round,that.Global.EnumUserStatus.normal,'主题招商演讲企业');
                  } else {
                    that.$message.error(res.message);
                    return false;
                  }
                });
            }
            }
            });

        }
      });

    },
  },
}
</script>
<style>
/* .demo-tabs > .el-tabs__content {
  padding: calc(100vw * 32 / 1920)px;
  color: #6b778c;
  font-size: calc(100vw * 32 / 1920)px;
  font-weight: 600;
} */
</style>
<style lang="scss" scoped>
</style>